var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QCard',{attrs:{"flat":"","bordered":""}},[_c('QCardSection',{staticClass:"q-pa-lg row"},[_c('div',{staticClass:"row col items-center"},[_vm._v(" "+_vm._s(_vm.addressString)+" ")]),_c('QBtn',{attrs:{"flat":"","round":"","size":"sm","icon":"eva-edit-outline"},on:{"click":function($event){return _vm.$emit('edit')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }